import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import Loader from '~components/Loader'
import Sprite from '~components/Sprite'
import classNames from 'classnames'

const Zoom = ({ images, title, index, onClose }) => {
  const [loading, setLoading] = useState(true)
  const imageRefs = useRef([])
  const loadedCountRef = useRef(0)

  useEffect(() => {
    const closeHandler = (e) => {
      if (e.type === 'keyup' && e.key === 'Escape') {
        onClose && onClose()
      }
    }

    document.addEventListener('keyup', closeHandler)
    toggleZoomOverlay(true)

    return () => {
      document.removeEventListener('keyup', closeHandler)
      toggleZoomOverlay(false)
    }
  }, [onClose])

  const handleOnLoad = () => {
    loadedCountRef.current += 1

    if (loadedCountRef.current === images.length) {
      setLoading(false)
      scrollToImage()
    }
  }

  const scrollToImage = () => {
    const image = imageRefs.current[index]
    if (image) {
      image.scrollIntoView()
    }
  }

  const toggleZoomOverlay = (toggle) => {
    if (toggle) {
      document.body.classList.add('overflow-y-hidden', 'lg:overflow-y-hidden')
      document.body.classList.remove('lg:overflow-y-visible')
    } else {
      document.body.classList.remove('overflow-y-hidden', 'lg:overflow-y-hidden')
      document.body.classList.add('lg:overflow-y-visible')
    }
  }

  return (
    <>
      {loading && <Loader />}

      <div className={classNames('fixed w-full h-full z-50 top-0 left-0 right-0 overflow-y-scroll overflow-scrolling bg-white', { invisible: loading })}>
        <div className="w-full -my-0.5">
          <button
            type="button"
            onClick={onClose}
            className="w-10 h-10 fixed right-5 top-5 md:top-10 md:right-10 flex items-center justify-center rounded-1/2 bg-transparent hover:bg-white focus:bg-white transition-colors duration-150 ease-in-out"
          >
            <span className="w-4 h-4 block" aria-hidden="true">
              <Sprite name="cross" />
            </span>
          </button>

          {images && images.map((image, idx) => (
            <figure
              key={image.id}
              className={classNames('w-full my-0.5 block', { 'animate-opacity': !loading })}
            >
              <img
                src={image.url_zoom}
                alt={title}
                className="w-full block"
                onLoad={handleOnLoad}
                ref={(el) => { imageRefs.current[idx] = el }}
              />
            </figure>
          ))}
        </div>
      </div>
    </>
  )
}

Zoom.propTypes = {
  title: PropTypes.string,
  images: PropTypes.array,
  index: PropTypes.number,
  onClose: PropTypes.func,
  className: PropTypes.string
}

export default Zoom
